import { render } from "./ImageFileItem.vue?vue&type=template&id=66a21bea"
import script from "./ImageFileItem.vue?vue&type=script&lang=js"
export * from "./ImageFileItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__